export const ITEM = {
  add: "/item",
  get: "/items",
  image: "/item/image",
  imageUpc: "/item/upc",
  getStoreItems: "/items/store",
  publicGet: "/public/items",
  getById: "/item", //pass id in query
  update: "/item", // pass id in body
  updateImage: "/item/image", // pass id in body
  remove: "/item", //pass id in query
};
